import { EnvironmentProviders } from '@angular/core';
import { provideHighcharts } from 'highcharts-angular';
import Highcharts from '../shared/highcharts/highcharts-instance';

export function provideAppHighcharts(): EnvironmentProviders {
  return provideHighcharts({
    instance: () => Promise.resolve(Highcharts),
    modules: () => [],
    timeout: 0,
  });
}
